import { name } from "../../../module-federation.config";

export const getAppEntityName = (entityName: string): string => {
  return `${name}-${entityName}`;
};